import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import { ManagerNavbar, Sidebar, AppMain } from './components';

export default {
  name: 'AdminLayout',
  components: {
    ManagerNavbar: ManagerNavbar,
    Sidebar: Sidebar,
    AppMain: AppMain
  },
  data: function data() {
    return {
      routerItems: []
    };
  },


  computed: _extends({}, mapGetters(['manage', 'manageRouters'])),

  mounted: function mounted() {},


  methods: {
    navClick: function navClick(index) {}
  }
};